module.exports = __webpack_public_path__ + "static/media/izlozba (6).210d5708.jpg";